export const HOST_QUERY_KEYS = {
  all: ['hosts'] as const,
  list: () => [...HOST_QUERY_KEYS.all, 'list'] as const,
  detail: (id: string) => [...HOST_QUERY_KEYS.all, 'detail', id] as const,
} as const
